import axios, { getServerErrorMessage } from '../utils/axios'
import * as c from '../constants/ApprovalRequestHistoryConstants'
import {
  SPECIAL_ORDER_TYPE_SECURE,
  SPECIAL_ORDER_TYPE_NON_SECURE,
} from '../constants/ApprovalRequestConstants'

export const fetchNonStockedApprovalRequestHistory = enrollmentId => dispatch => {
  dispatch({ type: c.FETCH_ENROLLMENT_APPROVAL_REQUEST_HISTORY_PENDING, payload: { enrollmentId } })

  return axios
    .get(`${Config.API_URL}/v2/orders/enrollment/${enrollmentId}/nonstocked-approval-history`)
    .then(res => {
      dispatch({
        type: c.FETCH_ENROLLMENT_APPROVAL_REQUEST_HISTORY_FULFILLED,
        payload: { enrollmentId, approvalHistory: res.data },
      })
    })
    .catch(err => {
      const errMsg = getServerErrorMessage(err)
      dispatch({ type: c.FETCH_ENROLLMENT_APPROVAL_REQUEST_HISTORY_REJECTED, payload: errMsg })
    })
}

export const fetchAncillaryMaterialsApprovalRequestHistory = (id, type) => dispatch => {
  let endpoint = ''
  switch (type) {
    case SPECIAL_ORDER_TYPE_SECURE:
      endpoint = 'ancillary-materials-approval-request-history'
      break

    case SPECIAL_ORDER_TYPE_NON_SECURE:
      endpoint = 'non-secure-ancillary-materials-approval-request-history'
      break
  }
  dispatch({ type: c.FETCH_ANCILLARY_MATERIALS_APPROVAL_REQUEST_HISTORY_PENDING, payload: { id } })

  return axios
    .get(`${Config.API_URL}/orders/special-order/${id}/${endpoint}`)
    .then(res => {
      dispatch({
        type: c.FETCH_ANCILLARY_MATERIALS_APPROVAL_REQUEST_HISTORY_FULFILLED,
        payload: { id, approvalHistory: res.data },
      })
    })
    .catch(err => {
      const errMsg = getServerErrorMessage(err)
      dispatch({
        type: c.FETCH_ANCILLARY_MATERIALS_APPROVAL_REQUEST_HISTORY_REJECTED,
        payload: errMsg,
      })
    })
}

export const fetchExceptionTestingApprovalRequestHistory = id => dispatch => {
  dispatch({ type: c.FETCH_EXCEPTION_TESTING_APPROVAL_REQUEST_HISTORY_PENDING, payload: { id } })

  return axios
    .get(`${Config.API_URL}/orders/special-order/${id}/exception-approval-request-history`)
    .then(res => {
      dispatch({
        type: c.FETCH_EXCEPTION_TESTING_APPROVAL_REQUEST_HISTORY_FULFILLED,
        payload: { id, approvalHistory: res.data },
      })
    })
    .catch(err => {
      const errMsg = getServerErrorMessage(err)
      dispatch({
        type: c.FETCH_EXCEPTION_TESTING_APPROVAL_REQUEST_HISTORY_REJECTED,
        payload: errMsg,
      })
    })
}

export const fetchOffCycleTestingApprovalRequestHistory = id => async dispatch => {
  dispatch({ type: c.FETCH_OFFCYCLE_TESTING_APPROVAL_REQUEST_HISTORY_PENDING, payload: { id } })
  try {
    const res = await axios.get(
      `${Config.API_URL}/orders/approval-requests/off-cycle/${id}/history`
    )
    dispatch({
      type: c.FETCH_OFFCYCLE_TESTING_APPROVAL_REQUEST_HISTORY_FULFILLED,
      payload: { id, approvalHistory: res.data },
    })
  } catch (e) {
    const errMsg = getServerErrorMessage(e)
    dispatch({
      type: c.FETCH_OFFCYCLE_TESTING_APPROVAL_REQUEST_HISTORY_REJECTED,
      payload: errMsg,
    })
  }
}

export const fetchOrdersAfterDeadlineApprovalRequestHistory = id => dispatch => {
  dispatch({
    type: c.FETCH_ORDERS_AFTER_DEADLINE_APPROVAL_REQUEST_HISTORY_PENDING,
    payload: { id },
  })

  return axios
    .get(
      `${Config.API_URL}/orders/special-order/${id}/orders-after-deadline-approval-request-history`
    )
    .then(res => {
      dispatch({
        type: c.FETCH_ORDERS_AFTER_DEADLINE_APPROVAL_REQUEST_HISTORY_FULFILLED,
        payload: { id, approvalHistory: res.data },
      })
    })
    .catch(err => {
      const errMsg = getServerErrorMessage(err)
      dispatch({
        type: c.FETCH_ORDERS_AFTER_DEADLINE_APPROVAL_REQUEST_HISTORY_REJECTED,
        payload: errMsg,
      })
    })
}

export const fetchReshipmentsApprovalRequestHistory = id => dispatch => {
  dispatch({
    type: c.FETCH_RESHIPMENTS_APPROVAL_REQUEST_HISTORY_PENDING,
    payload: { id },
  })

  return axios
    .get(`${Config.API_URL}/orders/special-order/${id}/reshipment-approval-request-history`)
    .then(res => {
      dispatch({
        type: c.FETCH_RESHIPMENTS_APPROVAL_REQUEST_HISTORY_FULFILLED,
        payload: { id, approvalHistory: res.data },
      })
    })
    .catch(err => {
      const errMsg = getServerErrorMessage(err)
      dispatch({
        type: c.FETCH_RESHIPMENTS_APPROVAL_REQUEST_HISTORY_REJECTED,
        payload: errMsg,
      })
    })
}
